module.exports = __webpack_public_path__ + "img/icon-documentation.9f2f3e93.svg";